module.exports = __webpack_public_path__ + "static/img/index1.0df66bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1.png
// module id = NpHd
// module chunks = 7